import { Formik, Form } from "formik";
import { useState } from "react";
import useTutorial from "../../../hooks/useTutorial";
import { BaSeIcon, BaSeInput, BaSeGrid, BaSeGridItem } from "@base/react";
import TitleWithPopover from "../../../components/title-with-popover";

const TutorialInventoryTurnOver = () => {
  const [form] = useState([{ order: 0, days: 0, value: 0 }]);
  const PAGE_KEY = "giroDeEstoque";

  useTutorial({
    currentStep: "13",
    pageKey: "giroDeEstoque",
    previousKey: "prazosDePagamento",
    steps: [
      {
        element: ".inventory-turnover",
        popover: {
          title: "Giro de Estoque",
          description: `Informe a renovação do seu estoque! Registre a quantidade de dias para reposição e o percentual
          das compras para otimizar sua gestão financeira.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["resultadosEMetas"]) {
        tutorials["resultadosEMetas"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step inventory-turnover">
      <TitleWithPopover title="Giro de Estoque" size={5} />

      <Formik>
        {() => (
          <Form>
            {form.map(({ order, days, value }) => {
              return (
                <div key={order} className="grid-buttons-area">
                  <BaSeGrid>
                    <BaSeGridItem size={5}>
                      <BaSeInput
                        isDisabled
                        inputMode="tel"
                        typeInput="tel"
                        maxLength={3}
                        value={days}
                        size="medium"
                        placeholder=""
                        mask={Number}
                        label="Dias"
                        width="100%"
                      />
                    </BaSeGridItem>
                    <BaSeGridItem size={5}>
                      <div className="top-input">
                        <BaSeInput
                          isDisabled
                          inputMode="decimal"
                          typeInput="tel"
                          prefix="% "
                          maxLength={8}
                          value={value}
                          size="medium"
                          placeholder="%"
                          label="% das compras"
                          width="100%"
                          mask="decimal"
                        />
                      </div>
                    </BaSeGridItem>
                    <BaSeGridItem size={1}>
                      <div className="remove-button">
                        <button
                          type="button"
                          className="btn-without-style btn-add-more"
                          disabled
                          style={{
                            cursor: "no-drop",
                          }}
                        >
                          <BaSeIcon
                            color="#C0C0C0"
                            description="Adicionar"
                            name="minus-square"
                            size={24}
                          />
                        </button>
                      </div>
                    </BaSeGridItem>
                  </BaSeGrid>
                </div>
              );
            })}
            <div className="result">
              <BaSeGrid>
                <BaSeGridItem size={5}>
                  <p>
                    Atenção: a soma dos percentuais lançados DEVE SER IGUAL a
                    100%.
                  </p>
                </BaSeGridItem>
                <BaSeGridItem size={5}>
                  <div className={`base-input-container`}>
                    <BaSeInput
                      inputMode="decimal"
                      typeInput="tel"
                      suffix="%"
                      size="medium"
                      placeholder="%"
                      width="100%"
                      mask="decimal"
                      isDisabled={true}
                    />
                  </div>
                </BaSeGridItem>
              </BaSeGrid>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialInventoryTurnOver;
